import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static get targets() {
        return ["isPoll", "pollContainer", "addAPollButton"];
    }

    get postAttachmentController() {
        return this.application.getControllerForElementAndIdentifier(this.element, "post-attachment");
    }

    addAPoll(e) {
        e.preventDefault();
        this.postAttachmentController.clearGif();
        this.postAttachmentController.clearImage();
        const gifButton = this.element.querySelector("[data-post-attachment-target='addAGifButton']");
        const imageButton = this.element.querySelector("[data-post-attachment-target='addAnImageButton']");
        if (gifButton) gifButton.disabled = true;
        if (imageButton) imageButton.disabled = true;
        this.addAPollButtonTarget.disabled = true;
        this.isPollTarget.value = "True";
        this.pollContainerTarget.classList.remove("d-none");
    }

    removePoll(e) {
        e.preventDefault();
        this.pollContainerTarget.classList.add("d-none");
        this.isPollTarget.value = "False";
        this.addAPollButtonTarget.disabled = false;
        const gifButton = this.element.querySelector("[data-post-attachment-target='addAGifButton']");
        const imageButton = this.element.querySelector("[data-post-attachment-target='addAnImageButton']");
        if (gifButton) gifButton.disabled = false;
        if (imageButton) imageButton.disabled = false;
    }
}